import { render, staticRenderFns } from "./personal-data.vue?vue&type=template&id=a06d49f6&scoped=true&"
import script from "./personal-data.vue?vue&type=script&lang=js&"
export * from "./personal-data.vue?vue&type=script&lang=js&"
import style0 from "./personal-data.vue?vue&type=style&index=0&id=a06d49f6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06d49f6",
  null
  
)

export default component.exports